import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API, axios } from "@/api";
import { ArrowLeft, Lightbulb, Info, Loader2 } from "lucide-react";
import { trackPageView } from "@/lib/track";

export default function TipsPage() {
  const navigate = useNavigate();
  const [tips, setTips] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openSection, setOpenSection] = useState(null);

  useEffect(() => {
    trackPageView("tips");
    (async () => {
      try { const res = await axios.get(`${API}/tips`); setTips(res.data); }
      catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><Loader2 className="w-8 h-8 animate-spin text-sky-500" /></div>;

  const sections = [
    { key: "home_sheet", title: "Home Screen", color: "bg-sky-50 text-sky-700" },
    { key: "all_freebies", title: "All Deals", color: "bg-purple-50 text-purple-700" },
    { key: "maximizing_value", title: "Maximizing Value", color: "bg-green-50 text-green-700" },
  ];

  return (
    <div className="min-h-screen bg-slate-50" data-testid="tips-page">
      <div className="bg-white border-b border-slate-200 p-4 pt-6 flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="p-2 rounded-full bg-slate-100" data-testid="back-btn"><ArrowLeft className="w-5 h-5 text-slate-600" /></button>
        <h1 className="text-xl font-bold text-slate-800 flex items-center gap-2"><Lightbulb className="w-5 h-5 text-green-500" />Tips & Guide</h1>
      </div>
      <div className="px-4 mt-4 space-y-3">
        {sections.map((section) => (
          <div key={section.key} className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
            <button onClick={() => setOpenSection(openSection === section.key ? null : section.key)} className={`w-full p-4 text-left text-sm font-semibold flex items-center justify-between ${section.color}`} data-testid={`tips-${section.key}`}>
              {section.title}
              <span className="text-xs">{openSection === section.key ? "Hide" : "Show"}</span>
            </button>
            {openSection === section.key && tips?.[section.key] && (
              <div className="p-4 border-t border-slate-100">
                <ul className="space-y-2">{tips[section.key].map((tip, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-slate-600"><Info className="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5" /><span>{tip}</span></li>
                ))}</ul>
              </div>
            )}
          </div>
        ))}
        {tips?.about && (
          <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-4 mt-4">
            <h3 className="font-semibold text-slate-700 text-sm mb-2">About</h3>
            <div className="space-y-1 text-xs text-slate-500">
              <p>Version: {tips.about.version}</p>
              <p>Total Businesses: {tips.about.total_businesses}</p>
              <p>Last Updated: {tips.about.last_updated}</p>
              <p className="mt-2 italic">{tips.warning}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
